import React from 'react';
import { Link } from 'react-router-dom';
import { EmptyState } from '../ui';

/**
 * Full-page Design System v2 status card for invitation outcomes
 * (already set up, link replaced, signed in as someone else, etc.).
 * Actions: [{ label, to? , href?, onClick?, variant: 'primary' | 'ghost' | 'link' }]
 */
const actionClass = {
  primary:
    'inline-flex items-center justify-center gap-2 bg-secondary text-white px-8 py-3.5 rounded-full font-bold hover:brightness-110 active:scale-95 transition-all shadow-warm',
  ghost:
    'inline-flex items-center justify-center gap-2 border border-secondary text-secondary px-8 py-3.5 rounded-full font-bold hover:bg-secondary hover:text-white transition-all',
  link: 'inline-flex items-center justify-center text-sm font-bold text-secondary hover:underline rounded-full px-4 py-2',
};

const ActionItem = ({ action }) => {
  const className = actionClass[action.variant || 'primary'];
  if (action.to) {
    return (
      <Link to={action.to} className={className}>
        {action.label}
      </Link>
    );
  }
  if (action.href) {
    return (
      <a href={action.href} className={className}>
        {action.label}
      </a>
    );
  }
  return (
    <button type="button" onClick={action.onClick} className={className} disabled={action.disabled}>
      {action.label}
    </button>
  );
};

export const InviteStatusCard = ({ icon, title, body, detail, actions = [], footer }) => (
  <main className="min-h-screen bg-main-bg flex items-center justify-center px-4 sm:px-6 py-12">
    <section className="w-full max-w-lg bg-section-bg p-3 sm:p-6 rounded-[2.5rem]">
      <div className="bg-white rounded-2xl border border-amber-100/30 shadow-warm">
        <EmptyState icon={icon} title={title} body={body}>
          {detail && (
            <p className="-mt-4 mb-8 text-sm font-medium text-slate-500">
              {detail}
            </p>
          )}
          {actions.length > 0 && (
            <div className="flex flex-col items-center gap-3 w-full max-w-xs">
              {actions.map((action) => (
                <ActionItem key={action.label} action={action} />
              ))}
            </div>
          )}
        </EmptyState>
      </div>
      {footer && (
        <p className="text-center text-xs font-medium text-slate-500 mt-5 px-4">{footer}</p>
      )}
    </section>
  </main>
);

export default InviteStatusCard;
